import addDays from 'date-fns/add_days';
import eachDay from 'date-fns/each_day';
import format from 'date-fns/format';

/**
 * Given a date or dateString it adds a few days to that date & formats the date in a certain format
 * @param date could be a string like YYYY-MM-DD or a Date object
 * @param numberOfDays the number of days to add
 * @param formatString the format string to format the date
 * @returns {string}
 */
export function addDaysAndFormat(
  date: Date | string,
  numberOfDays: number,
  formatString: string = 'YYYY-MM-DD',
) {
  return formatDate(addDays(date, numberOfDays), formatString);
}

export function formatDate(date: Date | string, formatString = 'YYYY-MM-DD') {
  return format(date, formatString);
}

/**
 * Checks if a date string provided is in YYYY-MM-DD format
 */
export function isYYYY_MM_DD(dateStr: string) {
  if (!dateStr) return false;
  return !!dateStr.match(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/);
}

/**
 * Returns all dates in between two days
 * @param startDate the date to start from
 * @param endDate the date to end at
 * @param exclusive should the last date be excluded?
 */
export function getDatesBetween(
  startDate: string | Date,
  endDate: string | Date,
  exclusive = true,
) {
  const daysInBetween = eachDay(startDate, endDate);
  if (exclusive) daysInBetween.pop();
  return daysInBetween;
}

/**
 * This number represents a day in seconds
 */
export const DAY_IN_SECONDS = 86400;

/**
 * This number represents a day in minutes
 */
export const DAY_IN_MINUTES = 1440;
